<template>
    <article class="overflow-hidden rounded-[2rem] shadow-[0_1rem_2.5rem_rgba(23,25,35,0.12)]" :style="{ backgroundColor: color, color: textColor }">
        <div class="grid items-stretch lg:grid-cols-[0.9fr_1.1fr]">
            <div class="flex min-h-[22rem] items-center justify-center px-6 pt-8 sm:px-10 lg:min-h-[30rem] lg:pt-0">
                <div class="flex h-[20rem] w-full max-w-[22rem] items-start justify-center overflow-hidden rounded-t-[1.25rem] border border-white/20 bg-black/10 shadow-[0_1rem_2rem_rgba(0,0,0,0.15)] sm:h-[24rem] lg:h-[28rem]">
                    <img :src="image" class="h-full w-full object-cover object-top" :alt="`${name} project preview`" loading="lazy">
                </div>
            </div>

            <div class="flex flex-col justify-center px-7 py-10 text-left sm:px-10 lg:px-14 lg:py-14">
                <div v-if="stats?.length" class="flex flex-wrap gap-x-8 gap-y-4">
                    <div v-for="stat in stats" :key="`${name}-${stat.context}`">
                        <div class="text-3xl font-extrabold tracking-tight sm:text-4xl">{{ stat.number }}</div>
                        <div class="mt-1 text-xs font-bold uppercase tracking-[0.14em] opacity-70">{{ stat.context }}</div>
                    </div>
                </div>

                <h3 class="mt-10 text-3xl font-extrabold leading-tight tracking-tight sm:text-5xl">{{ name }}</h3>
                <p class="mt-5 max-w-xl text-base leading-relaxed opacity-85 sm:text-lg">{{ description }}</p>

                <a v-if="url" :href="url" class="mt-8 inline-flex w-fit items-center gap-2 rounded-full border-2 border-current px-5 py-3 text-sm font-extrabold transition hover:bg-white hover:text-[#2B2949]">
                    View project
                    <ArrowUpRight class="h-4 w-4" aria-hidden="true" />
                </a>
            </div>
        </div>
    </article>
</template>
<script>
import { ArrowUpRight } from '@lucide/vue';
export default {
    props: {
        name: String,
        description: String,
        url: String,
        image: String,
        stats: Array,
        color: {
            type: String,
            default: '#E4E4E4'
        },
        textColor: {
            type: String,
            default: '#fff'
        }
    },
    components: {
        ArrowUpRight
    }
}
</script>